import { FC, RefObject } from 'react';
import { Box, Stack, Typography, IconButton } from '@mui/material';
import { VyIcon } from '@vy/ui-design-system';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';

type DateEditModeProps = {
  displayDate: string;
  calendarIconRef: RefObject<HTMLButtonElement>;
  onCalendarClick: () => void;
  onConfirm: () => void;
  onCancel: () => void;
};

export const DateEditMode: FC<DateEditModeProps> = ({
  displayDate,
  calendarIconRef,
  onCalendarClick,
  onConfirm,
  onCancel,
}) => {
  const dateTextStyle = {
    color: 'rgba(13, 27, 39, 0.87)',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '20px',
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <Stack
        direction="row"
        sx={{
          justifyContent: "space-between",
          alignItems: "center",
          gap: 0.5,
          height: "40px",
          minWidth: '154px',
          border: '1px solid #E0E0E0',
          borderRadius: '4px',
          padding: '4px 12px'
        }}>
        <Typography variant="body2" sx={dateTextStyle}>
          {displayDate}
        </Typography>
        <IconButton ref={calendarIconRef} size="small" onClick={onCalendarClick}>
          <VyIcon icon="Calendar" transform="scale(0.8)" />
        </IconButton>
      </Stack>
      <IconButton onClick={onConfirm} size="small">
        <CheckIcon color="success" sx={{ fontSize: '20px' }} />
      </IconButton>
      <IconButton onClick={onCancel} size="small">
        <CloseIcon color="inherit" sx={{ fontSize: '20px' }} />
      </IconButton>
    </Box>
  );
};
